export interface Notification {
  id: number
  type: string
  description: string
  notificationTime: string
  read: boolean
  readTime: string
  notificationDisplayType: number
  notificationType: number
  caseId: number
  case: {
    caseNumber: string | null
    caseType: string | null
  }
  delivered?: boolean | null
}

export enum NotificationDisplayType {
  Information = 1,
  Success = 2,
  Error = 3
}
